export default __webpack_public_path__ + "156fb7c83f91b050ff8594dba408bfd4.png";